// Lets whichever tab is currently mounted (Участники/Жеребкування/Рейтинг)
// hand its own dynamic search-chip options (player names, group letters,
// bracket places) up to Tournament.js's one global search box - same shape
// as ScheduleTable's own locally-computed `searchOptions`, just published
// across the tree instead of used in place, since the search box itself
// lives in Tournament.js while the data it should offer lives inside
// whichever tab is actually mounted. Tournament.js resets this to `[]` on
// every tab switch so a previous tab's stale options can't linger before the
// newly-mounted one publishes its own.
export const tournamentSearchOptionsSubscribers = new Set();

export const publishTournamentSearchOptions = (options) => {
    tournamentSearchOptionsSubscribers.forEach(cb => cb(options));
};